"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isThemeFeatureDescription = isThemeFeatureDescription;
exports.isIframeComponentFeatureDescription = isIframeComponentFeatureDescription;
exports.isEditorFeatureDescription = isEditorFeatureDescription;
const domain_core_1 = require("@standardnotes/domain-core");
const ComponentArea_1 = require("../Component/ComponentArea");
function isThemeFeatureDescription(feature) {
    return 'content_type' in feature && feature.content_type === domain_core_1.ContentType.TYPES.Theme;
}
function isIframeComponentFeatureDescription(feature) {
    return ('content_type' in feature &&
        feature.content_type === domain_core_1.ContentType.TYPES.Component &&
        [ComponentArea_1.ComponentArea.Editor, ComponentArea_1.ComponentArea.EditorStack].includes(feature.area));
}
function isEditorFeatureDescription(feature) {
    return (feature.note_type != undefined ||
        feature.area === ComponentArea_1.ComponentArea.Editor);
}
